import {Dispatch, FC, ReactNode, SetStateAction, useEffect, useState} from 'react'
import {CustomInputs} from '../../../../../../_metronic/helpers/components/CustomInputs'
import {Stuffid} from '../../../stuffid-management/stuffids-list/core/_models'
import {getStuffidByCode} from '../../../stuffid-management/stuffids-list/core/_requests'
import {getStuffIdSearchUrl} from '../../../stuffid-management/stuffidSite'
import {useIsOnPremises} from '../../../../auth/core/useOnPremises'
import {StuffIdInfo} from './StuffIdInfo'

type Props = {
  stuffidState: {
    stuffid: string
    setStuffid: Dispatch<SetStateAction<string>>
  }
  stuffidInfoState: {
    stuffidInfo: Stuffid | null | undefined
    setStuffidInfo: Dispatch<SetStateAction<Stuffid | null | undefined>>
  }
  isDisabled: boolean
  isRequired?: boolean
  error?: ReactNode
  label?: ReactNode
}

const ProductStuffIdEdit: FC<Props> = ({
  stuffidState,
  stuffidInfoState,
  isDisabled,
  isRequired = true,
  error,
  label,
}) => {
  const [first, setFirst] = useState(true)
  // The bank's own install looks the code up here but has no ID page to search in (the user, 2026-10-25).
  const onPremises = useIsOnPremises()

  useEffect(() => {
    if (
      !first ||
      (first && (stuffidInfoState.stuffidInfo == undefined || stuffidInfoState.stuffidInfo == null))
    ) {
      setFirst(false)
      stuffidInfoState.setStuffidInfo(undefined)
      if (stuffidState.stuffid && stuffidState.stuffid != '' && stuffidState.stuffid.length == 13) {
        getStuffidInfo(stuffidState.stuffid)
      }
    } else {
      setFirst(false)
    }
  }, [stuffidState.stuffid])

  useEffect(() => {}, [stuffidInfoState.stuffidInfo])

  const getStuffidInfo = (stid: string, date?: string) => {
    if (stuffidInfoState.stuffidInfo && stuffidInfoState.stuffidInfo.cd == stid) {
      return
    }
    getStuffidByCode(stid, date)
      .then((data) => {
        stuffidInfoState.setStuffidInfo(data)
      })
      .catch(() => {
        if (stuffidState.stuffid == stid) {
          stuffidInfoState.setStuffidInfo(null)
        }
      })
  }

  return (
    <>
      <div className='row'>
        <div className='col-lg-6 col-md-12'>
          <CustomInputs
            type='text'
            label={label ? label : 'شناسه عمومی/اختصاصی'}
            isRequired={isRequired}
            stateValue={{value: stuffidState.stuffid, setValue: stuffidState.setStuffid}}
            isDisabled={isDisabled}
            max={13}
            hint={
              onPremises ? undefined : (
                <div className='fs-7 mt-2'>
                  <a
                    href={getStuffIdSearchUrl(stuffidState.stuffid)}
                    target='_blank'
                    rel='noreferrer'
                  >
                    <i className='las la-search text-primary me-1'></i>
                    شناسه را نمی‌دانید؟ جستجوی شناسه کالا/خدمت (صفحه جدید)
                  </a>
                </div>
              )
            }
            error={error}
          />
        </div>
        <div className='col-lg-6 col-md-12'>
          {stuffidState.stuffid && (
            <div className='border border-dashed border-success p-5'>
              {stuffidInfoState.stuffidInfo ? (
                <StuffIdInfo stuffidInfo={stuffidInfoState.stuffidInfo} />
              ) : (
                <>
                  {stuffidInfoState.stuffidInfo === undefined && (
                    <div className='text-center text-primary blink p-5'>در حال جستجو...</div>
                  )}
                  {stuffidInfoState.stuffidInfo === null && (
                    <div className='text-center text-danger blink p-5'>کد اشتباه است</div>
                  )}
                </>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export {ProductStuffIdEdit}
